<template>
    <div class="ibox">

        <div class="ibox-title">

            <h5>Secretarias</h5>


            <div class="ibox-tools">
                <a class="btn btn-primary" id="ln_adicionar" @click="showModal">
                    <i class="fa fa-plus-circle"></i> Nova Secretaria
                </a>
            </div>
        </div>

        <div class="ibox-content">

            <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover m-table">

                    <thead>
                    <tr>
                        <th>Nome da Secretaria</th>
                        <th class="hidden-xs hidden-sm" style="width: 150px;">Data do Cadastro</th>
                        <th>Situação</th>
                        <th class="text-right">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in list" :id="'tr-' + item.id">
                            <td>{{item.name}}</td>
                            <td>{{item.created_at | datetimeBr}}</td>
                            <td>{{item.is_active}}</td>
                            <td>
                                <link-destroy-component
                                    :line-id="'tr-' + item.id"
                                    :link="route('secretarias.destroy', item.id)">
                                </link-destroy-component>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>

        <modal-default active-back-drop ref="addModal" show-footer title="Adicionar Secretaria"
                       :fixed-height="true">
            <div class="form-row">

                <div class="form-group col-md-12">
                    <label for="name">Nome</label>
                    <input v-model="form.name" class="form-control"
                           placeholder="">
                </div>
            </div>
            <template v-slot:actions>
                <button type="button" class="btn btn-primary text-xs font-weight-bold mt-2"
                        @click="store"> SALVAR
                </button>
            </template>
        </modal-default>
    </div>
</template>

<script>

import ModalDefault from "./ModalDefault.vue";

export default {
    name: "Secretarias",
    components: {ModalDefault},
    props: {
        entidade: {
            type: Object
        }
    },
    data() {
        return {
            route,
            form: {
                name: ''
            },
            list: []
        }
    },
    mounted(){
      this.all();
    },
    methods: {
        clear() {
            this.form.name = ''
        },
        showModal() {
            this.clear()
            this.$refs.addModal.show();
        },
        async all() {
            let result = await axios.get(route('secretarias.index'))
            this.list = result.data.data;
        },
        store() {
            let app = this;

            if (!this.form.name) {
                showMessage('w', "Preencha todos os campos!")
                return;
            }
            axios.post(route('secretarias.store'), this.form).then((res) => {
                showMessage('s', "Cadastrado com sucesso")
                app.$refs.addModal.hide();
                app.all()
            })
        },
    }
}
</script>

<style scoped>

</style>
